import { MainLayoutContent } from "components/layouts/MainLayoutContent";
import { AppRouteType } from "navigation/registryRoutes";
import slugs from "navigation/slugs";

import React from 'react';
const Point = React.lazy(() => import("../page/Point"));

const routes: AppRouteType[] = [
  {
    path: slugs.point,
    component: Point,
    container: MainLayoutContent,
    isAuthNeeded: true,
  },
];

export default routes;
